<template>
  <div class="field__label flex items-center justify-between">
    <label
      class="field__label__text block text-xs mb-2"
      :for="field.attributes.slug"
      v-text="field.attributes.label"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'FieldLabel',
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
}
</script>
